import { parse as cssWhat } from 'css-what';
export function findAndRemoveFirstVdomChild(vdom, selector) {
  const node = findFirstVdomChild(vdom, selector);
  if (node === undefined) return false;

  // Set to empty fragment
  node.tag = '[';
  node.attrs = {
    removedViaVdomUtils: true
  };
  node.children = [];
  return true;
}
export function findFirstVdomChild(vdom, selector, manipulationFunc) {
  const parsedSelector = cssWhat(selector);
  return searchChildren(vdom, parsedSelector, manipulationFunc);
}
function searchChildren(vdom, selectors, manipulationFunc) {
  let nodes;
  if (!Array.isArray(vdom)) {
    nodes = [vdom];
  } else {
    nodes = vdom;
  }
  let found = undefined;
  nodes.some(node => {
    if (typeof node === 'boolean' || typeof node === 'number' || typeof node === 'string' || node === null || node === undefined) return false;
    if (Array.isArray(node)) {
      let result = searchChildren(node, selectors, manipulationFunc);
      if (result) {
        found = result;
        return true;
      }
      return false;
    }
    if (doesChildMatchSelectors(node, selectors)) {
      found = node;
      return true;
    }
    if (Array.isArray(node.children)) {
      let result = searchChildren(node.children, selectors);
      if (result) {
        found = result;
        return true;
      }
      return false;
    }
    return false;
  });
  if (manipulationFunc && found) manipulationFunc(found);
  return found;
}
function doesChildMatchSelectors(child, selectors) {
  return selectors.some(selector => {
    return selector.every(criterion => {
      var _attr, _attr$startsWith, _attr2, _attr2$endsWith, _attr3, _attr3$split, _attr3$split$includes;
      switch (criterion.type) {
        case 'tag':
          return child.tag === criterion.name;
        case 'attribute':
          if (!child.attrs) return false;
          if (criterion.name === 'class') criterion.name = 'className';
          let attr = child.attrs[criterion.name];
          if (criterion.name === 'className' && typeof attr === 'string') {
            attr = attr.trim();
          }
          if (criterion.ignoreCase && typeof attr === 'string') {
            attr = attr.toLowerCase();
            criterion.value = criterion.value.toLowerCase();
          }
          switch (criterion.action) {
            case 'exists':
              return child.attrs.hasOwnProperty(criterion.name);
            case 'equals':
              return attr === criterion.value;
            case 'start':
              return ((_attr = attr) == null || (_attr$startsWith = _attr.startsWith) == null ? void 0 : _attr$startsWith.call(_attr, criterion.value)) || false;
            case 'end':
              return ((_attr2 = attr) == null || (_attr2$endsWith = _attr2.endsWith) == null ? void 0 : _attr2$endsWith.call(_attr2, criterion.value)) || false;
            case 'element':
              return ((_attr3 = attr) == null || (_attr3$split = _attr3.split) == null || (_attr3$split = _attr3$split.call(_attr3, ' ')) == null || (_attr3$split$includes = _attr3$split.includes) == null ? void 0 : _attr3$split$includes.call(_attr3$split, criterion.value)) || false;
          }
      }
      return false;
    });
  });
}
flarum.reg.add('ianm-follow-users', 'forum/util/findVdomChild', { findAndRemoveFirstVdomChild: findAndRemoveFirstVdomChild,findFirstVdomChild: findFirstVdomChild, });